class HostInquirer {
    constructor(context) {
        this.context = context
    }

    getAllElementsFromQuery(query) {
        let elements = Array.from(this.context.document.querySelectorAll(query))

        if (!elements.length) {
            elements = Array.from(this.context.document.querySelectorAll(query.toLowerCase()))
        }

        return elements
    }

    getAllElementsFromClassName(className) {
        return [
            ...Array.from(this.context.document.getElementsByClassName(className.toLowerCase())),
            ...Array.from(this.context.document.getElementsByClassName(className)),
        ]
    }
}

export default HostInquirer
